import { render, staticRenderFns } from "./DocStatus.vue?vue&type=template&id=ac72b82e&scoped=true&"
import script from "./DocStatus.vue?vue&type=script&lang=js&"
export * from "./DocStatus.vue?vue&type=script&lang=js&"
import style0 from "./DocStatus.vue?vue&type=style&index=0&id=ac72b82e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac72b82e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
